<template lang="pug">
  b-container
    .d-flex.justify-content-between.mb-2
      h4.mb-0 Nueva Plantilla
      b-button.b-0(variant="link", size="sn", :to="{name : 'Whatsapp Templates'}")
        chevron-left-icon.icon-md
        span Volver a plantillas
    // CATEGORIES CARD
    b-card(bg-variant="light")
      b-form-group.mb-0(label-size="sm", label="Selecciona una plantilla" )
      b-row
        b-col(md="4", v-for="catOpt in categoriesOptions", :key="catOpt.value" )
          b-card.mb-0.h-100(body-class="p-2 position-relative", @click="selectCategory(catOpt)")
            b-form-radio.position-absolute(v-model="category", :value="catOpt.value", style="right:0; top:0.25rem")
            .d-flex.align-items-center
              b-avatar.mr-2(rounded, size="lg", :variant="category === catOpt.value ? 'primary' : 'soft-primary'" )
                v-icon.icon-xl(:name="catOpt.icon")
              .text-sm
                div {{catOpt.text}}
                small.text-justify {{catOpt.description}}
    // TEMPLATE BODY
    b-card
      b-row
        // BODY FORM
        b-col(md="7")
          // NAME
          b-form-group(label="Nombre de plantilla", label-size="sm", description="No utilices caracteres especiales como: ñ, %, @, ´." )
            b-input-group(:append="`${templateName.length}/512`", size="sm")
              b-form-input.br-0(placeholder="Nombre de plantilla", :value="templateName", @update="templateName = $event.toLowerCase().replace(/ /g,'_')", maxlength="512", :state="validateState(templateName)")
          // LANGUAGE
          b-form-group(label="Idioma", label-size="sm" , invalid-feedback="Selecciona un idioma")
            b-form-select( :options="languages", v-model="language", size="sm", :state="validateState(language)")
              template(#first)
                b-form-select-option(:value="null" disabled) Selecciona un idioma
          //HEADER
          b-form-group(label="Cabecera", label-size="sm" )
            b-form-row
              b-col(cols="auto")
                b-form-select(v-model="header.format", :options="headerFormats", size="sm", @change="header.text = headerExampleText = ''; headerExampleFile = null")
              b-col(v-if="header.format === 'TEXT'")
                b-form-group
                  b-input-group(:append="`${header.text.length}/60`", size="sm")
                    b-form-input.br-0(placeholder="Cabecera de mensaje", :value="header.text", maxlength="60", @update="validateHeader", :state="validateState(header.text)")
                b-form-group(label="Ejemplo para variable de cabecera", label-size="sm", v-if="headerVar")
                  b-form-input(size="sm", :placeholder="`Valor de {{${headerVar[0]}}}`", v-model="headerExampleText", :state="validateState(headerExampleText)")
              b-col(v-else-if="header.format")
                b-form-group
                  template(#description, v-if="headerExampleFile")
                    b-link.text-sm.text-danger(@click="headerExampleFile = null") Quitar
                  b-form-file(size="sm", :placeholder="`Selecciona ${headerFileConfig[header.format].placeholder} de ejemplo`", v-model="headerExampleFile", :disabled="uploading", :accept="headerFileConfig[header.format].accept", browse-text="Seleccionar", :state="validateState(headerExampleFile)")
          // BODY
          div
            b-form-group(label="Texto", label-size="sm" , invalid-feedback="Completa texto de mensaje", :disabled="isAuthentication")
              b-card.mb-2(body-class="p-2" )
                // EDITOR BUTTONS
                b-form-row.align-items-center.justify-content-end.mb-2
                  b-col(cols="auto")
                    b-button#emoji-icon(variant="light", size="sm")
                      smile-icon.icon-sm
                  b-col(cols="auto", v-for="editor in textEditors", :key="editor.name")
                    b-button(variant="light", size="sm", @click="addSpecialText(editor.char)")
                      v-icon(:name="editor.name")
                  b-col(cols="auto")
                    b-button(variant="light", size="sm", @click="addVariable", v-html="'{{n}}'")
                // TEMPLATE BODY
                b-form-group(:description="`${templateBody.length}/1024`", invalid-feedback="Ingresa el cuerpo del mensaje" )
                  b-form-textarea#body_input.b-0.bt-2.rounded-0(size="sm", placeholder="Cuerpo del mensaje", v-model="templateBody",  maxlength="1024", :state="validateState(templateBody)")
                // BODY VARIABLES
                b-form-group(label="Variables del mensaje", label-size="sm", v-show="bodyVars.length" )
                  b-form-input.mb-2(v-for="(vars, index) in bodyVars", :key="index", :placeholder="`Valor para {{${vars}}}`", size="sm", v-model="bodyExample[index]", :state="validateState(bodyExample)")
            // EMOJI POPOVER
            b-popover(:show.sync="showEmojis", target="emoji-icon", placement="top", triggers="click")
              template(#title)
                .d-flex.align-items-center.justify-content-between
                  span Insertar emoji
                  x-icon.icon-md.hover-danger.pointer(@click="showEmojis = false")
              Picker.w-100.border-0(set="facebook", :style="{height: '250px'}", v-bind="pickerParams", @select="insertEmoji", :data="emojiIndex", title="Emojis", :i18n="i18n")
          // FOOTER
          div
            // TEXT
            b-form-group(label="Pie de página", label-size="sm" )
              b-input-group(:append="`${footer.length}/60`", size="sm" )
                b-form-input.br-0(placeholder="Escribe un pie de página", :value="footer", maxlength="60", @update="validateFooter")
            // BUTTONS
            b-form-group(label="Botones", label-size="sm", )
              b-form-select(size="sm", v-model="buttonsType", :options="buttonTypes" @change="addButton(true)", :disabled="isAuthentication")
            b-form-row.mb-3(v-for="(button, index) in buttons", :key="index")
              b-col(lg="4", v-if="button.type !== 'QUICK_REPLY' && button.type !== 'OTP'")
                b-form-group(label="Acción", label-size="sm")
                  b-form-select(size="sm", :options="actionTypes", v-model="button.type", :disabled="buttons.length >= 2")
              b-col(lg="4", v-if="button.type === 'PHONE_NUMBER'")
                b-form-group(label="Teléfono", label-size="sm", invalid-feedback="El numero debe de ser de 10 dígitos" )
                  b-input-group(size="sm", :append="`${button.phone_number.length}/20`")
                    b-form-input.br-0(placeholder="Teléfono", v-model="button.phone_number", maxlength="20", :state="validateState(button.phone_number)")
              b-col(lg="4", v-if="button.type === 'URL'" )
                b-form-group(label="URL", label-size="sm")
                  b-input-group(size="sm", :append="`${button.url.length}/2000`")
                    b-form-input.br-0(placeholder="URL", :value="button.url", maxlength="2000", @input="validateButtonUrl($event, button)", :state="validateState(button.url)")
                b-form-group(label="Ejemplo de variable en URL", label-size="sm", description="Utiliza el dominio más la variable", v-if="buttonUrlVar(button)")
                  b-form-input(size="sm", :placeholder="`https://website.com/{{${buttonUrlVar(button)[0]}}}`", v-model="buttonExampleUrl", :state="validateState(buttonExampleUrl)")
              b-col
                b-form-group(:label="`Texto del botón ${button.type === 'OTP' ? 'para copiar código' : ''}`", label-size="sm")
                  b-input-group(size="sm")
                    b-form-input.br-0(placeholder="Texto", :value="button.text", maxlength="25", :state="validateState(button.text)", @input="button.text = $event.replace(/\{\{.[0-9]+\}\}/g, '')")
                    b-input-group-append
                      b-input-group-text {{button.text.length}}/25
                    b-input-group-append(v-if="button.type !== 'OTP'")
                      b-input-group-text.bl-0(@click="removeButton(index)")
                        trash-2-icon.icon-sm.pointer.hover-danger
            b-button(size="sm", variant="outline-primary", @click="addButton()", :disabled="buttons.length === buttonsLimit", v-if="buttonsType") Agregar botón
        // BODY PREVIEW
        b-col(md="5")
          MessageTemplatePreview(v-bind="previewData")
      hr.b-1.my-4
      b-row.justify-content-end
        b-col(cols="5")
          b-button(variant="an", block, :disabled="loading", @click="saveData")
            b-spinner(v-if="loading", small, variant="white" )
            span(v-else) Guardar plantilla
</template>

<script>
import {mapActions} from "vuex";
import MessageTemplatePreview from "@/components/MessageTemplatePreview";
import { UploadFile } from '@/helpers/upload-file'
import data from 'emoji-mart-vue-fast/data/facebook.json'
import {Picker, EmojiIndex} from "emoji-mart-vue-fast";
import mixpanel from "@/mixpanel";

const emojiIndex = new EmojiIndex(data)

export default {
  name: "WhatsappNewTemplate",
  data: () => {
    return {
      loading: false,
      uploading: false,
      missingData: false,
      showEmojis: false,
      category: 'MARKETING',
      categoriesOptions: [
        { value: "MARKETING", text: "Marketing", description: 'Envía promociones, información o  invitaciones.', icon: 'bullhorn'},
        { value: "UTILITY", text: "Utilidad", description: 'Envía actualizaciones sobre transacciones y facturación.', icon: 'file-invoice'},
        { value: "AUTHENTICATION", text: "Autenticación", description: 'Envía códigos para verificar una cuenta o un inicio de sesión.', icon: 'unlock'}
      ],
      languages: [
        {value: "es", text: "Español"},
        {value: "es_MX", text: "Español (Mex)"},
        {value: "en", text: "Ingles"}
      ],
      headerFormats: [
        { value: null, text: "Ninguna"},
        { value: "TEXT", text: "Texto"},
        { value: "IMAGE", text: "Imagen"},
        { value: "DOCUMENT", text: "Documento"},
        { value: "VIDEO", text: "Video"},
      ],
      headerFileConfig: {
        IMAGE: {accept: 'image/*', placeholder: 'imagen'},
        DOCUMENT: {accept: '.pdf', placeholder: 'documento'},
        VIDEO: {accept: '.mp4', placeholder: 'video'},
      },
      textEditors: [
        { char: "*", name: "bold"},
        { char: "_", name: "italic"},
        { char: "~", name: "strikethrough"},
        //{ char: "```", name: "code"},
      ],
      buttonTypes: [
        { value: null, text: "Ninguno"},
        { value: "QUICK_REPLY", text: "Botón de respuesta rápida"},
        { value: "CALL_TO_ACTION", text: "Ejecutar Acción"},
      ],
      actionTypes: [
        { value: "PHONE_NUMBER", text: "Llamar a número"},
        { value: "URL", text: "Ir a sitio web"},
      ],
      pickerParams: {
        showSearch: false,
        showCategories: false,
        showPreview: false
      },
      i18n: {
        search: 'Buscar',
        notfound: 'No hay resultados',
        categories: {
          search: 'Búsqueda',
          recent: 'Usados frecuentemente',
          people: 'Caras y personas',
          nature: 'Naturaleza',
          foods: 'Comida y bebidas',
          activity: 'Actividades',
          places: 'Lugares y viajes',
          objects: 'Objetos',
          symbols: 'Símbolos',
          flags: 'Banderas',
          custom: 'Custom',
        }
      },
      templateName: '',
      templateBody: '',
      language: null,
      header: {
        format: null,
        text: ''
      },
      headerExampleText: '',
      headerExampleFile: null,
      header_file: null,
      footer: '',
      buttonsType: null,
      buttonExampleUrl: '',
      buttons: [],
      bodyExample: [],
      regex: /(?<=\{\{)\d+?(?=}})/g,
      emojiIndex
    }
  },
  computed: {
    headerVar () {
      return this.header.text.match(this.regex)
    },
    bodyVars () {
      let match = this.templateBody.match(this.regex)
      return match ? match.filter((value, index, self) => self.indexOf(value) === index) : []
    },
    buttonsLimit () {
      return this.buttonsType === 'QUICK_REPLY' ? 3 : 2
    },
    previewData () {
      return {
        header: this.header,
        header_example_text: this.headerExampleText,
        header_example_file: this.headerExampleFile,
        body_message: this.templateBody,
        body_example: this.bodyExample,
        footer: this.footer,
        buttons: this.buttons
      }
    },
    isAuthentication() {
      return this.category === 'AUTHENTICATION'
    }
  },
  methods: {
    ...mapActions([
      'message_template/create',
      'whatsapp/upload_file',
      'helpers/upload_file'
    ]),
    validateState (value) {
      if(value) return null
      return this.missingData ? false : null
    },
    validateHeader (event) {
      let index = 0
      this.header.text = event.replace(this.regex, match => ++index >= 2 ? '' : match).replace(/\{\{}}/g, "")
    },
    validateFooter (event) {
      this.footer = event.replace(this.regex, '').replace(/\{\{}}/g, '')
    },
    addSpecialText (char) {
      let el = document.getElementById("body_input")
      if(el.selectionStart === el.selectionEnd) {
        this.templateBody += `${char}${char}`
        return
      }
      try{
        let message = this.templateBody
        message = message.slice(0, el.selectionStart) + char + message.slice(el.selectionStart);
        this.templateBody = message.slice(0, el.selectionEnd + 1) + char + message.slice(el.selectionEnd + 1);
      }catch(e){
        console.log("ERROR ADDING SPECIAL TEXT", e)
      }
    },
    addVariable () {
      let max = 1
      if(this.bodyVars.length) {
        max += Math.max.apply(null, this.bodyVars)
      }
      this.templateBody += `{{${max}}}`
    },
    insertEmoji (emoji) {
      this.templateBody += emoji.native
    },
    selectCategory({ value } ){
      this.category = value
      if(value === 'AUTHENTICATION') {
        this.templateBody = 'Tu código de verificación es:'
        this.buttons = []
        this.buttonsType = null
        this.buttons.push({
          type: 'OTP',
          otp_type: 'COPY_CODE',
          text: '',
        })
      } else {
        const authBtn = this.buttons.find(({ type }) => type === 'OTP')
        if(authBtn) this.buttons = []
      }
    },
    addButton (clear = false) {
      if(clear) this.buttons = []
      switch (this.buttonsType) {
        case 'QUICK_REPLY':
          this.buttons.push({type:"QUICK_REPLY", text: ""})
          break
        case 'CALL_TO_ACTION':
          const type = this.buttons.find(el => el.type === "PHONE_NUMBER") ? 'URL' : 'PHONE_NUMBER'
          const btn = {type, text: "", url: "",  phone_number: "" }
          this.buttons.push(btn)
          break
        default:
          this.buttons = []
          break
      }
      this.missingData = false
    },
    removeButton (index) {
      this.buttons.splice(index, 1)
    },
    validateButtonUrl (event, button) {
      let index = 0
      button.url = event.replace(this.regex, match => ++index >= 2 ? '' : match).replace(/\{\{}}/g, '')
    },
    buttonUrlVar (button) {
      const match =  button.url.match(this.regex)
      if(!match) this.buttonExampleUrl = ''
      return match
    },
    async saveData () {

      for (const string of ['category', 'templateName', 'templateBody', 'language']) {
        if(!this[string]) {
          this.missingData = true
          return
        }
      }

      for (let i = 0; i < this.bodyVars.length; i++) {
        if(!this.bodyExample[i]) {
          this.missingData = true
          return
        }
      }

      if(this.header.format === 'TEXT' && !this.header.text) {
        this.missingData = true
        return
      }

      for (let button of this.buttons) {
        if(!button.text) {
          return this.missingData = true
        }
        switch (button.type) {
          case 'PHONE_NUMBER':
            if(!button.phone_number || button.phone_number.length < 10) {
              return this.missingData = true
            }
            delete button.url
            break
          case 'URL':
            if(!button.url) {
              return this.missingData = true
            }
            if(this.buttonUrlVar(button) && !this.buttonExampleUrl) {
              return this.missingData = true
            }
            delete button.phone_number
            break
        }
      }

      if(this.headerExampleText) {
        this.header.example = {
          header_text: [this.headerExampleText]
        }
      }

      if(this.headerExampleFile) {
        try {
          let handle = await this.getFileHandle(this.headerExampleFile)
          if(handle) {
            this.header.example = {
              header_handle: [handle]
            }
          } else {
            this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
            return
          }
        } catch (e) {
          console.log(e)
          this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
          return
        }
      }

      this.createTemplate().then(() =>{})
    },
    async uploadDefaultFile (file) {
      const{headerExampleFile, templateName} = this
      const extension = file.name.split('.').pop()
      const fileTemplateName = templateName.replace(/ /g, '_')
      const params = {
        filename: `${fileTemplateName}_WA_TEMPLATE.${extension}`,
        extension
      }
      return await UploadFile.call(this, headerExampleFile, params)
    },
    getFileHandle (file) {
      const self = this
      return new Promise(resolve => {
        let form = new FormData()
        form.append('file', file)
        this['whatsapp/upload_file']({
          waba_id: this.$route.params.wabaId,
          form: form,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
              return resolve(false)
            } else {
              return resolve(res.resource)
            }
          }
        });
      })
    },
    async createTemplate () {
      this.loading = true
      const self = this
      const{ headerExampleFile, category, language, buttonExampleUrl} = this
      let defaultUrl;
      if(headerExampleFile)defaultUrl = await this.uploadDefaultFile(this.headerExampleFile)
      if(buttonExampleUrl) {
        this.buttons.forEach(el => {
          if(el.type === "URL") {
            el.example = [buttonExampleUrl]
          }
        })
      }
      this['message_template/create']({
        waba_id: this.$route.params.wabaId,
        name: this.templateName,
        body: this.templateBody,
        body_example: this.bodyExample,
        header: this.header,
        footer: this.footer,
        buttons: this.buttons,
        defaultUrl,
        category,
        language,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)
          self.$message.success('Plantilla creada')
          this.saveMixpanel(`Whatsapp Templates: Create ${category} template`)
          if(this.footer) {
            this.saveMixpanel('Whatsapp Templates: Create whit footer')
          }
        }
      });
    },
    saveMixpanel (event) {
      const {email, admin_id, role_id} = this.getCurrentUser()
      mixpanel.track(event, {
        account_id: this.$route.params.account_id,
        unique_id: email,
        admin_id,
        role_id
      });
    }
  },
  components: {MessageTemplatePreview, Picker}
}
</script>

<style scoped>

</style>